import { socket } from "../core/socket";
import { store } from "../core/store";
import { loadIdentity, clearIdentity } from "../core/storage";

/**
 * Handles the "same identity opened in another tab" case (§ user report): the
 * server tells this socket its player association is about to be taken over by a
 * newer connection. Rather than silently leaving this tab looking mysteriously
 * disconnected, show a clear banner with a one-click way to reclaim this tab.
 */
export function initSessionBanner(): void {
  const banner = document.getElementById("session-replaced-banner")!;
  const reclaimBtn = document.getElementById("session-reclaim-btn") as HTMLButtonElement;

  socket.on("session:replaced", () => {
    banner.classList.remove("hidden");
  });

  reclaimBtn.addEventListener("click", () => {
    const lobbyCode = store.getState().lobbyCode;
    const identity = lobbyCode ? loadIdentity(lobbyCode) : null;
    if (!identity || !lobbyCode) {
      banner.classList.add("hidden");
      return;
    }
    socket.emit(
      "reconnect:request",
      { playerId: identity.playerId, reconnectToken: identity.reconnectToken },
      (res) => {
        if (res.ok) {
          store.setState({ joined: true, myPlayerId: identity.playerId, isSpectator: !!res.isSpectator });
          banner.classList.add("hidden");
        } else {
          clearIdentity(lobbyCode);
          store.setState({ joined: false, myPlayerId: null, isHost: false });
          banner.classList.add("hidden");
        }
      }
    );
  });
}
